import { SyntheticEvent, useEffect } from "react";

import { Autocomplete, FormControl, TextField } from "@mui/material";

import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";

import { getHubspotUrl } from "helpers/Sources/createSource";

import CrmSourceMappingArea from "components/CrmSourceMappingArea";
import LoginButton from "components/molecules/LoginButton";

import {
    HUBSPOT_MODULE_OPTIONS,
    HubSpotCRMProps,
    HubSpotModuleOption,
} from "./HubSpotCRM.types";

const HubSpotCRM = ({
    isModal,
    isCrmView,
    onMappingSuccess,
    sourceId,
    name,
    onNameChange,
    isAuthLoading,
    setIsAuthLoading,
    onLoginSuccess,
    selectedHubspotModule,
    setSelectedHubspotModule,
    isLoginButtonDisabled,
    useHostFooter = false,
    registerFooterAction,
}: HubSpotCRMProps) => {
    const language = useSelector(
        (state: any) => state.languagesState.languages,
    );

    useEffect(() => {
        return () => {
            setSelectedHubspotModule(null);
        };
    }, [setSelectedHubspotModule]);

    const onModuleChange = (
        _: SyntheticEvent,
        selectedOption: HubSpotModuleOption | string | null,
    ) => {
        setSelectedHubspotModule(
            typeof selectedOption === "string" ? null : selectedOption,
        );
    };

    return (
        <div>
            {isCrmView ? (
                <CrmSourceMappingArea
                    sourceId={sourceId}
                    sourceType={"hub"}
                    mappingSuccess={onMappingSuccess}
                    isModal={isModal}
                    hideSaveButton={useHostFooter}
                    registerFooterAction={registerFooterAction}
                />
            ) : (
                <>
                    <Form.Group controlId="exampleForm.ControlInput1">
                        <FormControl className="mb-3" style={{ width: "100%" }}>
                            <TextField
                                name="name"
                                label={language?.trackers_page?.name ?? "Name"}
                                variant="outlined"
                                onChange={onNameChange}
                                value={name}
                                placeholder={
                                    language?.source_modal?.please_write_name ??
                                    "Please write name"
                                }
                                className="source-name-input"
                            />
                        </FormControl>
                    </Form.Group>
                    <FormControl className="mb-3" style={{ width: "100%" }}>
                        <Autocomplete
                            onChange={onModuleChange}
                            value={selectedHubspotModule}
                            disabled={!name}
                            options={HUBSPOT_MODULE_OPTIONS}
                            getOptionLabel={(option) =>
                                typeof option === "string"
                                    ? option
                                    : (option?.label ?? "")
                            }
                            isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                            }
                            freeSolo
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={
                                        language?.source_modal
                                            ?.choose_a_module ??
                                        "Choose a module"
                                    }
                                />
                            )}
                        ></Autocomplete>
                    </FormControl>
                    <div className="position-relative overflow-hidden z-1">
                        <LoginButton
                            getAuthUrl={getHubspotUrl}
                            getAuthUrlData={selectedHubspotModule?.value}
                            getAuthUrlResponseTransform={(response) => {
                                return response?.data?.url;
                            }}
                            code="hubspot"
                            paramNames={["code"]}
                            onSuccess={onLoginSuccess}
                            dataTransform={(params) => ({
                                code: params.code,
                                source_type: "hub",
                            })}
                            onAuthUrlError={() => setIsAuthLoading(false)}
                            logoSrc="/assets/images/hubspot.png"
                            logoStyle={{ borderRadius: "50%" }}
                            buttonText={
                                language?.buttons?.connect_with_hubspot ??
                                "Connect with HubSpot"
                            }
                            disabled={
                                isLoginButtonDisabled ||
                                !selectedHubspotModule?.value
                            }
                            isLoadingExternal={isAuthLoading}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default HubSpotCRM;
export type {
    HubSpotCRMProps,
    HubSpotLoginSuccessData,
    HubSpotModuleOption,
    HubSpotModuleValue,
} from "./HubSpotCRM.types";
